import { Injectable } from '@angular/core';
import {
  ApiEndpointsService,
  ApiHttpErrorService,
  ApiHttpService
} from '@services/index';
import { shareReplay, take } from 'rxjs/operators';
import { DocumentTypeResponse } from 'src/app/_models/ApiResponse/documentTypeResponse';
import { DocumentTypeCatagories } from '../config/enums/documentTypeCatagories';
import { AllDocTypesResponse } from '../_models/ApiResponse/allDocTypesResponse';
import { ApiResponse } from '../_models/ApiResponse/apiResponse';

@Injectable({ providedIn: 'root' })
export class DocumentTypeService {
  private _allDocTypes: AllDocTypesResponse;
  public set allDocTypes(value: AllDocTypesResponse) {
    this._allDocTypes = value;
  }
  constructor(
    private httpService: ApiHttpService,
    private endpointsService: ApiEndpointsService,
    private httpErrorService: ApiHttpErrorService
  ) {}

  get organizationalDocTypes() {
    return this._allDocTypes.organizationalDocTypes;
  }

  get generalQualAndLearnershipDocTypes() {
    return this._allDocTypes.generalQualificationAndLearnershipDocTypes;
  }

  get studentDocTypes() {
    return this._allDocTypes.studentDocTypes;
  }

  get staffDocTypes() {
    return this._allDocTypes.staffDocTypes;
  }

  get poeGeneralDocTypes() {
    return this._allDocTypes.poeGeneralDocTypes;
  }

  get poeWorkplaceDocTypes() {
    return this._allDocTypes.poeWorkplaceDocTypes;
  }

  get poeAssessmentGuideDocTypes() {
    return this._allDocTypes.poeAssessmentGuideDocTypes;
  }

  get poeGroupGeneralDocTypes() {
    return this._allDocTypes.poeGroupGeneralDocTypes;
  }

  get poeFormativeAssessmentDocTypes() {
    return this._allDocTypes.poeFormativeAssessmentDocTypes;
  }

  get poeSummativeAssessmentDocTypes() {
    return this._allDocTypes.poeSummativeAssessmentDocTypes;
  }

  public getDocumentTypeViewValue(
    docTypeId: number,
    docTypeCatagory: DocumentTypeCatagories
  ): string {
    let documentTypes: DocumentTypeResponse[];

    switch (docTypeCatagory) {
      case DocumentTypeCatagories.staff:
        documentTypes = this.staffDocTypes;
        break;
      case DocumentTypeCatagories.student:
        documentTypes = this.studentDocTypes;
        break;
      case DocumentTypeCatagories.poeGeneral:
        documentTypes = this.poeGeneralDocTypes;
        break;
      case DocumentTypeCatagories.poeAssessmentGuide:
        documentTypes = this.poeAssessmentGuideDocTypes;
        break;
      case DocumentTypeCatagories.poeWorkplace:
        documentTypes = this.poeWorkplaceDocTypes;
        break;
      case DocumentTypeCatagories.poeGroupGeneral:
        documentTypes = this.poeGroupGeneralDocTypes;
        break;
      case DocumentTypeCatagories.poeSummativeAssessment:
        documentTypes = this.poeSummativeAssessmentDocTypes;
        break;
      case DocumentTypeCatagories.poeFormativeAssessment:
        documentTypes = this.poeFormativeAssessmentDocTypes;
        break;
      case DocumentTypeCatagories.organizational:
        documentTypes = this.organizationalDocTypes;
        break;
      case DocumentTypeCatagories.generalQualAndLearnership:
        documentTypes = this.generalQualAndLearnershipDocTypes;
        break;
      default:
        break;
    }

    return documentTypes.find((x) => x.id === docTypeId)?.documentType;
  }

  public getDocumentsTypes() {
    return this.httpService
      .get<ApiResponse<AllDocTypesResponse>>(
        this.endpointsService.allDocumentTypes()
      )
      .pipe(take(1));
  }

  public async load(): Promise<any> {
    try {
      await this.loadDocTypes();
    } catch (error) {
      this.httpErrorService.handle(error);
    }
  }

  private async loadDocTypes(): Promise<any> {
    const allDocTypesResponse = await this.httpService
      .get<ApiResponse<AllDocTypesResponse>>(
        this.endpointsService.allDocumentTypes()
      )
      .pipe(shareReplay(1))
      .toPromise();
    this.allDocTypes = allDocTypesResponse.data;
  }
}
